import { put, select, takeLatest } from 'redux-saga/effects'
import { BodySurveyConstants } from '../store/bodySurvey.constants'
import { IBodySurveyState } from '../store/bodySurvey.types'
import { getBodySurveySelector } from '../selectors'
import {
  saveBodySurvey,
  setDefaults,
  setEnabledZoom,
  setExaminationInProgress,
  setSequence,
  setZoomVisible,
} from '../store/bodySurvey.actions'
import { throwPcrException } from '../../../../pcr/store/pcr.actions'
import { deleteAssessment } from '../../../store/additionalAssessments.actions'
import { getComments } from '../../../../../components/commentSection/selectors'
import { ICommentsState } from '../../../../../components/commentSection/store/comments.types'
import { performWithMutexHOG } from '../../../../../services/mutexUtility.service'
import { IBurnsState } from '../../burns/store/burns.types'
import { IDrainsAndTubesState } from '../../drainsTubes/store/drainsAndTubes.types'
import { IObstetricsState } from '../../obstetrics/store/obstetrics.types'
import { getBurnsSelector } from '../../burns/selectors'
import { getDrainsAndTubesSelector } from '../../drainsTubes/selectors'
import { initialDrainsAndTubesState } from '../../drainsTubes/store/drainsAndTubes.reducers'
import { getObstetricsSelector } from '../../obstetrics/selectors'
import { initialObstetricsState } from '../../obstetrics/store/obstetrics.reducers'

export function* setBOD() {
  const bodySurvey: IBodySurveyState = yield select(getBodySurveySelector)
  const comments: ICommentsState = yield select(getComments)
  const burns: IBurnsState = yield select(getBurnsSelector)
  const drainsAndTubes: IDrainsAndTubesState = yield select(getDrainsAndTubesSelector)
  const obstetrics: IObstetricsState = yield select(getObstetricsSelector)

  const { commentPageTitle } = comments
  const { seq, __bod } = bodySurvey
  const { burnsExamData } = burns

  try {
    if (
      !__bod &&
      commentPageTitle.length === 0 &&
      drainsAndTubes === initialDrainsAndTubesState &&
      !burnsExamData.length &&
      obstetrics === initialObstetricsState
    ) {
      yield put(deleteAssessment(seq))
      yield put(setSequence(BodySurveyConstants.OPERATION_TYPE_DECREMENT))
    } else {
      yield put(saveBodySurvey())
    }
    yield put(setEnabledZoom(false))
    yield put(setDefaults(false))
    yield put(setZoomVisible(false))
    yield put(setExaminationInProgress(false))
  } catch (e) {
    yield put(throwPcrException(`setBOD() error: ${e}`))
  }
}

export function* setBODSaga() {
  yield takeLatest([BodySurveyConstants.SET_BOD], performWithMutexHOG, setBOD)
}
